export enum FindRecordOriginEnum {
  analysis = 'Gerenciar Análises',
  proposals = 'Gerenciar Propostas',
  policies = 'Gerenciar Apólices',
  canceleds = 'Gerenciar Canceladas',
  expireds = 'Gerenciar Expirados',
  claims = 'Sinistros'
}
